import {config} from "../config";
import {API, CLIENT, OPERATIONS, SESSIONS, SUMMARIZE, SUMMARY} from "./endpoints";
import {AxiosResponse} from "axios";
import axiosInstance from "./axios";

const backendUrl: string = config.backendApiUrl;
const baseUrl = `${backendUrl}/${API}/${CLIENT}`;

export enum SessionSummaryTypeEnum {
    SHORT = 'SHORT',
    LONG = 'LONG',
}

// Replace with getting data from REST endpoint when implemented on Truebar BE
export enum SessionSummaryModelEnum {
    GPT_4 = 'gpt-4',
    GPT_4_1 = 'gpt-4.1',
    GPT_4_1_NANO = 'gpt-4.1-nano',
    GPT_4_1_MINI = 'gpt-4.1-mini',
    GPT_3_5_TURBO = 'gpt-3.5-turbo',
}

export interface ISessionSummarizeSettings {
    summaryType: SessionSummaryTypeEnum;
    model: SessionSummaryModelEnum,
    enableKeywords: boolean,
    enableKeyPoints: boolean,
    enableSpeakers: boolean
    enableAgendaItems: boolean,
}


export const getSessionSummary = (
    sessionId: number
): Promise<AxiosResponse<any>> => {
    const url = baseUrl + `/${SESSIONS}/${sessionId}/${SUMMARY}`;
    return axiosInstance.get(url);
};

export const getSessionSummaryStatus = (
    sessionId: number
): Promise<AxiosResponse<any>> => {
    const url = baseUrl + `/${SESSIONS}/${sessionId}/${SUMMARY}`;
    return axiosInstance.head(url);
};

export const summarizeSession = (
    sessionId: number,
    settings: ISessionSummarizeSettings,
): Promise<AxiosResponse<any>> => {
    const url = baseUrl + `/${SESSIONS}/${sessionId}/${OPERATIONS}/${SUMMARIZE}`;
    return axiosInstance.put(
        url,
        settings
    );
};

export const summarizeSessionStatus = (
    sessionId: number,
): Promise<AxiosResponse<any>> => {
    const url = baseUrl + `/${SESSIONS}/${sessionId}/${OPERATIONS}/${SUMMARIZE}`;
    return axiosInstance.head(url);
};

